export const UNTITLED = "UNTITLED"
export const MASTER = "MASTER"